import type { ParsedAddOn } from '@t/addOn.types';
import type { Plan } from '@t/productOffering.types';

export const offeringToAddOn = (offering: Plan): ParsedAddOn => ({
  code: offering.planId,
  name: offering.name,
  price: offering.price,
  description: offering.description.summary,
  type: 'serviceAddOn',
  supportsQuantity: false,
  discountTag: offering.description.discountTag,
  discountMessage: offering.description.discountMessage,
});

/** Returns a human-readable constraint hint, or null if unconstrained. */
export const constraintLabel = (min: number, max: number): string | null => {
  if (min === 0 && max === 0) return null;
  if (min > 0 && max === 1) return `Select exactly 1`;
  if (min > 0 && max > 1) return `Select between ${min} and ${max}`;
  if (min > 0) return `Select at least ${min}`;
  if (max === 1) return `Select at most 1`;
  if (max > 1) return `Select up to ${max}`;
  return null;
};
